import {
    Select,
    SelectProps,
    SpaceBetween,
    Input,
    Button,
    Header
} from '@amzn/awsui-components-react';
import React, { useContext, useEffect, useState } from 'react';
import {PLIConfigStep, PLITemplateType} from 'src/models/calculation-builder/pli-config/PLIConfigTemplate';
import {CUSTOM_PLI, ALPHANUMERIC_SPACE_REGEX} from "src/components/calculation-builder/pli-config/Constants";
import {PLIConfigContext} from './PLIConfigContainer';

export default function PLITemplateSelector(props: {
    pliTemplates: PLITemplateType[],
    selectedPLITemplate?: PLITemplateType,
    onPLITemplateChanged: (selectedMode?: PLITemplateType) => void,
    overviewSectionSteps?: PLIConfigStep[] | undefined,
    reloadPLIConfig: () => void,
    onError?: (error: string | undefined) => void
}) {
    const { pliTemplates, selectedPLITemplate, onPLITemplateChanged, reloadPLIConfig, onError } = props;
    const {state, services} = useContext(PLIConfigContext);
    const [selectedPLIMode, setSelectedPLIMode] = React.useState<any>(null);
    const [dropdownOptions, setDropdownOptions] = useState<any>([]);
    const [isEditing, setIsEditing] = useState(false);
    const [headerText, setHeaderText] = useState("");
    const [originalHeaderText, setOriginalHeaderText] = useState("");
    const [savePayload, setSavePayload] = useState<any>(null);
    const [saveResult, isSaving, saveError] = services.pliConfigService.saveOverviewSectionPLIConfigStepName(savePayload);

    const findCustomPLIName = () => {
        const step = props.overviewSectionSteps?.find((step: PLIConfigStep) => step.sequence === 3);
        if (step) {
            setHeaderText(step.description);
            setOriginalHeaderText(step.description);
        }
    }

    const onSaveHeaderText = () => {
        setSavePayload({
            calculationNumber: state.pliConfigMetadata?.calculationNumber,
            oldStepDescription: originalHeaderText,
            newStepDescription: headerText
        });
    }

    useEffect(() => {
        if (saveResult) {
            reloadPLIConfig();
            setSavePayload(null);
        }
    }, [saveResult]);

    useEffect(() => {
        if (saveError) {
            onError?.(saveError);
            setSavePayload(null);
        }
    }, [saveError]);

    useEffect(() => {
        var options: SelectProps.Options[] = [];
        var previousGroup = "";
        var groupOptions: any[] = [];
        pliTemplates.forEach((template: PLITemplateType) => {
            if (template.group != previousGroup) {
                groupOptions = [];
                options.push({ label: template.group, options: groupOptions } as any);
                previousGroup = template.group;
            }
            groupOptions.push({ label: template.description, value: template.value } as any);
        })
        setDropdownOptions(options);
    },[pliTemplates])

    useEffect(() => {
        if (selectedPLIMode != null && selectedPLIMode.value !== selectedPLITemplate?.value) {
            onPLITemplateChanged(pliTemplates.find(x => x.value === selectedPLIMode.value));
        }
    },[selectedPLIMode])

    useEffect(() => {
        if (!selectedPLITemplate) return;

        if (selectedPLITemplate.value === CUSTOM_PLI) findCustomPLIName();

        setSelectedPLIMode({value: selectedPLITemplate.value, label: selectedPLITemplate.description})
    }, [selectedPLITemplate, props.overviewSectionSteps])

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div style={{ flex: '0 0 20%' }}>
                <Select
                    selectedOption={selectedPLIMode}
                    onChange={({ detail }) =>
                        setSelectedPLIMode(detail.selectedOption)
                    }
                    options={dropdownOptions}
                />
            </div>

            {selectedPLITemplate?.value === CUSTOM_PLI && (
                <div style={{flex: '1'}}>
                    {isEditing ? (
                        <SpaceBetween direction="horizontal" size="xs">
                            <Input
                                value={headerText}
                                onChange={({detail}) => {
                                    const value = detail.value.replace(ALPHANUMERIC_SPACE_REGEX, '');
                                    setHeaderText(value);
                                }}
                            />
                            <Button variant={'icon'} iconName={'check'} onClick={onSaveHeaderText}/>
                            <Button variant={'icon'} iconName={'close'} onClick={() => {
                                setHeaderText(originalHeaderText);
                                setIsEditing(false);
                            }}/>
                        </SpaceBetween>
                    ) : (
                        <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                            <Header variant="h3">{headerText}</Header>
                            <Button variant={'icon'} iconName={'edit'} onClick={() => setIsEditing(true)}/>
                        </SpaceBetween>
                    )}
                </div>
            )}
        </div>
    );
}